export function getPathFromUrl(fullUrl: string) {
  try {
    const url = new URL(fullUrl)
    return url.pathname
  } catch (e) {
    return fullUrl
  }
}
